export default __webpack_public_path__ + "static/media/left-arrow.06347840.svg";